module.exports = __webpack_public_path__ + "img/activities-7.8be309d3.jpg";